import { FormFieldState } from '@/common/form/FormFieldState';
import { FormStateBase } from '@/common/form';

export class RegistrationsDetailsFormStateNewCloudAccount extends FormStateBase {
    accountId: FormFieldState = new FormFieldState();
    companyName: FormFieldState = new FormFieldState();
    companyAddressLine1: FormFieldState = new FormFieldState();
    companyAddressLine2: FormFieldState = new FormFieldState();
    companyAddressCity: FormFieldState = new FormFieldState();
    companyAddressPostCode: FormFieldState = new FormFieldState();
    companyAddressState: FormFieldState = new FormFieldState();
    companyAddressCountryCode: FormFieldState = new FormFieldState();
    administrativeContactFirstName: FormFieldState = new FormFieldState();
    administrativeContactLastName: FormFieldState = new FormFieldState();
    administrativeContactPhone: FormFieldState = new FormFieldState();
    administrativeContactEmail: FormFieldState = new FormFieldState();
    billingAccountNumber: FormFieldState = new FormFieldState();
    customerIdentificationNumber: FormFieldState = new FormFieldState();

    constructor() {
        super();
        this.setForm(this);
    }
}
